export default "__VITE_ASSET__3fb72039__"